var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69623 11.5303C6.40334 11.2374 6.40334 10.7626 6.69623 10.4697L9.02448 8.14142C9.10259 8.06332 9.10259 7.93668 9.02448 7.85858L6.69623 5.53033C6.40334 5.23744 6.40334 4.76256 6.69623 4.46967C6.98913 4.17678 7.464 4.17678 7.75689 4.46967L10.5801 7.29289C10.9706 7.68342 10.9706 8.31658 10.5801 8.70711L7.75689 11.5303C7.464 11.8232 6.98913 11.8232 6.69623 11.5303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.9d7bc04b4a4bd0d83b3b79c8241aaa0a.svg";
export { ForwardRef as ReactComponent };